import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberPublicationsPage from "@/pages/member/MemberPublicationsPage";

export const Route = createFileRoute("/member/publications")({
  head: () => pageHead("Member · Publications", "AKIVA member · publications portal.", "/member/publications", true),
  component: MemberPublicationsPage,
});
